/* eslint-disable */
const mercadopago = new MercadoPago('TEST-831119dd-b9d5-41d0-aef0-f0c0f1c099f6', {
    locale: 'es-AR' // The most common are: 'pt-BR', 'es-AR' and 'en-US'
});
  
export default mercadopago;